module.exports = __webpack_public_path__ + "img/qris.78ba20ab.svg";